<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
      <div class="btn-box">
        <button-add :pathName="addCustom" v-if="permissionCodes.indexOf('017006001') !== -1"/>
        <button-export
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('017006003') !== -1"
          value="导出"/>
      </div>
      <input-select selectTitle="客户分类" :selectKey="'customIntendType'" :selectData="customIntendTypeList" @search="search"/>
      <input-search placeholder="住户名称" @search="searchKey" />
    </div>
    <table-main :tableHead="tableHead" :tableData="tableData" @toCurrentPage="toCurrentPage" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :operationArr="operationArr" />
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import ButtonAdd from '../../../components/Button/ButtonAdd'
  import ButtonDelete from '../../../components/Button/ButtonDelete'
  import ButtonExport from '../../../components/common/buttons/button-export'
  import ButtonUpload from '../../../components/common/buttons/button-upload'
  import InputSearch from '../../../components/Input/InputSearch'
  import InputSelect from '../../../components/Input/InputSelect'
  import TableMain from '../../../components/Table/TableMain'
  import {api} from '../../api/agent'
  import {errorHandler} from '../../../utils/errorHandler'
  import {nAlert, nSuccess} from '../../../utils/notice'
  import {bus} from '../../../utils/bus'

  export default {
    components: {
      TableMain,
      InputSelect,
      InputSearch,
      ButtonUpload,
      ButtonExport,
      ButtonDelete,
      ButtonAdd,
      Breadcrumb},
    name: 'custom-management',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '智慧合约',
          name: 'custom-management'
        }, {
          value: '客户管理'
        }],
        addCustom: 'custom-add',
        exportUrl: '',
        customIntendTypeList: [{
          key: '',
          label: '全部'
        }, {
          key: '0',
          label: '未分类'
        }, {
          key: '1',
          label: '潜在客户'
        }, {
          key: '2',
          label: '意向客户'
        }, {
          key: '3',
          label: '成交客户'
        }, {
          key: '4',
          label: '流失客户'
        }],
        tableHead: [{
          prop: 'enterpriseName',
          label: '住户名称'
        }, {
          prop: 'industry',
          label: '行业分类'
        }, {
          prop: 'oneContactPersonName',
          label: '联系人1姓名'
        }, {
          prop: 'oneContactPersonPhone',
          label: '联系人1手机'
        }, {
          prop: 'secContactPersonName',
          label: '联系人2姓名'
        }, {
          prop: 'secContactPersonPhone',
          label: '联系人2手机'
        }, {
          prop: 'recommendPersonName',
          label: '推荐人姓名'
        }, {
          prop: 'recommendPersonPhone',
          label: '推荐人手机'
        }, {
          prop: 'customIntendTypeText',
          label: '客户意向分类'
        }],
        tableData: [],
        total: 0,
        pageSize: 10,
        pageNum: 1,
        selectionArr: [],
        requestData: {
          searchKey: '',
          customIntendType: ''
        },
        operationArr: ['current']
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes

      this.getPage()
    },
    activated() {
      this.getPage()
    },
    methods: {
      beforeDownload () {
        this.exportUrl = `${api.exportCustom}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&customIntendType=${this.requestData.customIntendType}`
      },
      getPage () {
        let reqData = this.requestData
        reqData.pageNum = this.pageNum
        reqData.pageSize = this.pageSize
        this.$axios.post(api.getCustomPage, reqData)
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data.list
              data.map(v => {
                if (v.customIntendType === '0') {
                  v.customIntendTypeText = '未分类'
                } else if (v.customIntendType === '1') {
                  v.customIntendTypeText = '潜在客户'
                } else if (v.customIntendType === '2') {
                  v.customIntendTypeText = '意向客户'
                } else if (v.customIntendType === '3') {
                  v.customIntendTypeText = '成交客户'
                } else if (v.customIntendType === '4') {
                  v.customIntendTypeText = '流失客户'
                }
              })
              this.total = res.data.data.total
              this.tableData = data
            }
          })
          .catch(errorHandler('获取客户信息失败'))
      },
      search (v) {
        this.pageNum = 1
        this.requestData[v.key] = v.value
        this.getPage()
      },
      searchKey (v) {
        this.pageNum = 1
        this.requestData.searchKey = v
        this.getPage()
      },
      changePagination (data) {
        this.pageNum = data[0]
        this.pageSize = data[1]
        this.getPage()
      },
      changeSelection (codeArr) {
        this.selectionArr = codeArr
      },
      toCurrentPage (code) {
        this.$router.push({
          path: `/custom_current/${code}`
        })
      }
    }
  }
</script>

<style scoped>
  .search-line {
    display: flex;
    justify-content: space-between;
    margin: 20px 0;
  }
  .btn-box {
    display: flex;
    justify-content: flex-start;
  }
</style>

<style lang="less">
  .el-input--small .el-input__inner {
    line-height: 30px;
  }
</style>



// WEBPACK FOOTER //
// src/view/Agent/CustomManagement/CustomManagement.vue